import React from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {Responsive} from 'app/general/mediaqueries';
import {ToggleDiagramButton} from 'app/procedures/components/ProcedureDiagram/ToggleDiagramButton';
import {gt} from 'app/utils/i18n';

type ToggleChatButtonProps = {
  toggleWidget: () => unknown;
};

export const ToggleChatButton = ({toggleWidget}: ToggleChatButtonProps) => (
  <Responsive
    breakpoint="md"
    large={
      <LazyTooltip tooltip={gt('Chat with SweetAI')} placement="left">
        <ToggleDiagramButton
          deltaDistance={10}
          position="top"
          showingDiagram={false}
          toggleDiagram={toggleWidget}
          iconName={'fa-robot'}
        />
      </LazyTooltip>
    }
    small={
      <LazyTooltip tooltip={gt('Chat with SweetAI')} placement="left">
        <ToggleDiagramButton
          deltaDistance={-8}
          position="bottom"
          showingDiagram={false}
          toggleDiagram={toggleWidget}
          iconName={'fa-robot'}
        />
      </LazyTooltip>
    }
  />
);
